import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { PortfolioPerformanceSimpleReturnAndIRRModel } from '../../../Models/Models/PortfolioAnalysis/Performance/PortfolioPerformanceSimpleReturnAndIRRModel';
import { IJsonDate } from '../../../System/IJsonDate';
import { PerformanceMethod } from '../../../Constants/Enums/Domain/PerformanceMethod';

declare var IS_RUNNING_IN_APP_POOL;

export class PortfolioPerformanceSimpleReturnAndIRRClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, fromDateTime: IJsonDate, toDateTime: IJsonDate, performanceMethod: PerformanceMethod, subAccountHierarchyIds: Array<string>, inceptionDate: IJsonDate, isConsolidate: boolean): Promise<PortfolioPerformanceSimpleReturnAndIRRModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/PortfolioPerformanceSimpleReturnAndIRR/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fromDateTime: fromDateTime, toDateTime: toDateTime, performanceMethod: performanceMethod, subAccountHierarchyIds: subAccountHierarchyIds, inceptionDate: inceptionDate, isConsolidate: isConsolidate }

    return AjaxWrapper.get<PortfolioPerformanceSimpleReturnAndIRRModel, any>(url, data);
  }
}

